import React, { useState } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Stack,
  Typography,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import getTags from "../../api/store/getTags";
import updateTable from "../../api/store/updateTable";
import { useEffect } from "react";

const TableDialog = ({ tableData, open, setOpen }) => {
  const [table, setTable] = useState({
    ...tableData,
    PriceTable: tableData?.PriceTable || {},
  });
  const [tags, setTagsState] = useState([]);
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const data = await getTags();

        setTagsState(data.tags); // Adjust this if data structure differs
      } catch (err) {}
    };
    fetchTags();
    setTable({
      ...tableData,
      PriceTable: tableData?.PriceTable || {},
      Tags:tableData?.Tags ||[],
    });
  }, [tableData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTable({
      ...table,
      [name]: value,
    });
  };

  const handlePriceTableChange = (index, field, value) => {
    const updatedPriceTable = table.PriceTable;

    updatedPriceTable[field][index] = value;
    setTable({
      ...table,
      PriceTable: updatedPriceTable,
    });
  };

  const addPriceTableEntry = () => {
    let index=table.PriceTable.length+1
    let tmpTable=table.PriceTable
    tmpTable.Hour.push(index)
    tmpTable.FreeHour.push(0)
    tmpTable.Price.push(100)
    tmpTable.Discount.push(0)
    setTable({
      ...table,
      PriceTable: tmpTable,
    });
  };

  const removePriceTableEntry = (index) => {
    const updatedPriceTable = table.PriceTable;

    updatedPriceTable.Hour.splice(index, 1)
    updatedPriceTable.FreeHour.splice(index, 1)
    updatedPriceTable.Price.splice(index, 1)
    updatedPriceTable.Discount.splice(index, 1)

    setTable({
      ...table,
      PriceTable: updatedPriceTable,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      await updateTable(table?.Code, table);
      handleClose();
    } catch (error) {
      console.error("Failed to update table:", error);
    }
  };
  const handleTagChange = (event) => {
    const { name, checked } = event.target;
    const newTags = checked
      ? [...table.Tags, name]
      : table.Tags.filter((tag) => tag !== name);

    setTable((prevTable) => ({
      ...prevTable,
      Tags: newTags
    }));
  };
  const generateTagToggles = () => (
    <>
    <Typography marginRight={1} color={"error"} >注意:標籤僅供顯示給客人，內容不會影響任何優惠。</Typography>
    <Stack direction="row" alignItems={'center'}>
    <Typography marginRight={1}  variant="h6">標籤</Typography>
      {tags.map((tag, index) => (
        <FormControlLabel
        
          key={index}
          control={
            <Checkbox
            color="warning"
              checked={table?.Tags?.includes(tag)}
              onChange={handleTagChange}
              name={tag}
            />
          }
          label={tag}
        />
      ))}
    </Stack>
    </>

  );

  return (
    <Dialog maxWidth={"lg"} open={open} onClose={handleClose}>
      <DialogTitle align="center">{"編輯牌桌"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack direction={"row"} spacing={1}>
            <Box display={"flex"} width={"70%"} flexDirection={"column"}>
              <TextField
                autoFocus
                margin="dense"
                name="Code"
                label="店號"
                color="secondary"
                required
                variant="outlined"
                sx={{ width: "80%" }}
                value={table?.Code || ""}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                name="Name"
                label="桌名"
                required
                color="secondary"
                variant="outlined"
                sx={{ width: "80%" }}
                value={table?.Name || ""}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                name="Price"
                label="價格"
                required
                InputProps={{ inputProps: { min: 0, max: 10000 } }}
                color="secondary"
                variant="outlined"
                type="number"
                sx={{ width: "80%" }}
                value={table?.Price || 0}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                name="Description"
                label="描述"
                color="secondary"
                variant="outlined"
                sx={{ width: "80%" }}
                value={table?.Description || ""}
                onChange={handleChange}
              />
           {   generateTagToggles()}
            </Box>
            <Box>
              <Button
                variant="outlined"
                color="secondary"
                onClick={addPriceTableEntry}
              >
                新增價格表項目
              </Button>
              <TableContainer component={Paper}>
                <Table aria-label="price table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>時長(小時)</TableCell>
                      <TableCell>贈送小時</TableCell>
                      <TableCell>價格</TableCell>
                      <TableCell>折扣金額</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {table.PriceTable.Hour?.map((entry, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField disabled={true} type="number" value={index+1} size="small" />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            value={entry}
                            onChange={(e) =>
                              handlePriceTableChange(
                                index,
                                "Hour",
                                parseFloat(e.target.value)
                              )
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            value={table.PriceTable.FreeHour[index]}
                            onChange={(e) =>
                              handlePriceTableChange(
                                index,
                                "FreeHour",
                                parseFloat(e.target.value)
                              )
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            value={table.PriceTable.Price[index]}
                            onChange={(e) =>
                              handlePriceTableChange(
                                index,
                                "Price",
                                parseInt(e.target.value)
                              )
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            value={table.PriceTable.Discount[index]}
                            onChange={(e) =>
                              handlePriceTableChange(
                                index,
                                "Discount",
                                parseInt(e.target.value)
                              )
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Button
                            color="error"
                            onClick={() => removePriceTableEntry(index)}
                          >
                            刪除
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            取消
          </Button>
          <Button type="submit" color="secondary">
            確認
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TableDialog;
